import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const PrimaryInverseButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-primary-inverse-button">
      {children}
    </IfmsButton>
  );
});

PrimaryInverseButton.defaultProps = {
};

PrimaryInverseButton.propTypes = {
  size: PropTypes.oneOf(['extrasmall','regular', 'small', 'large']),
};

export default React.memo(PrimaryInverseButton);

